<div class="form-group row">
  <label class="col-sm-3 col-form-label" *ngIf="label">{{ label }}</label>
  <div [ngClass]="label != null ? 'col-sm-9' : 'col-12'">
    <textarea
      [ngClass]="{'border-none': border}"
      nbInput
      fullWidth
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [status]="(control.invalid && control.touched) ? 'danger' : ''"
      rows="{{rows}}"
    ></textarea>
    <span [ngxAppValidationMessageFor]="control" class="error-message">
    </span>
  </div>
</div>
